import { createModalStore } from '@/shared/lib/modal';

export const useScreenRecordModalStore = createModalStore();
